// userListActions.ts
let controlPanelRefreshCallback: null | (() => void) = null;

export const registerControlPanelRefresh = (callback: () => void) => {
  controlPanelRefreshCallback = callback;
};

export const triggerControlPanelRefresh = () => {
  controlPanelRefreshCallback?.();
};